import { render, staticRenderFns } from "./TypePeriodicityInsurance.vue?vue&type=template&id=619abb1f&scoped=true&"
import script from "./TypePeriodicityInsurance.ts?vue&type=script&lang=ts&"
export * from "./TypePeriodicityInsurance.ts?vue&type=script&lang=ts&"
import style0 from "./TypePeriodicityInsurance.vue?vue&type=style&index=0&id=619abb1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619abb1f",
  null
  
)

export default component.exports